import { render, staticRenderFns } from "./PaymentRequest.vue?vue&type=template&id=7cb924bc"
import script from "./PaymentRequest.vue?vue&type=script&lang=ts"
export * from "./PaymentRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports